import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import { device } from 'vqp-common';

import { StoreName, UserDropdown } from './'
import { StoreLogo } from '../common'
import { useStore } from '../../providers/store.provider';
import { makeStyles, MenuItem, Select, Tooltip } from '@material-ui/core';
import { StoreStatus } from './store-status/store-status';
import { HelpOutline } from '@material-ui/icons';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: ${props => props.theme.dimensions.headerHeightMobile}px;
    justify-content: center;
    background-color: ${props => props.theme.colors.primary};
    border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
    position: fixed;
    z-index: 10;
    @media ${device.desktop} {
        height: ${props => props.theme.dimensions.headerHeightDesktop}px;
    }
`
const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const StoreBaseWrapper = styled.div`
    background-color: orange;
    padding: 0px 8px 0px 16px;
    border-radius: 10px;
    font-size: 14px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    width: 115px;
    border: 1px solid #000;
    color: #000;
    margin-top: 5px;
`

const LogoWrapper = styled.div`
    width: 50px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    @media ${device.desktop} {
        width: 210px;
    }
`

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
    align-self: center;
    color: white;
    font-weight: 700;
    text-align: left;
    padding: 0 15px;
`

const NotificationWrapper = styled.div`
    margin-right: 40px;
    align-self: center;
`

const UserDropdownWrapper = styled.div`
    align-self: center;
    margin-left: 10px;
    padding-right: 15px;
`

const useStyles = makeStyles({
    select: {
        color: 'white',
        "& .MuiSvgIcon-root": {
            color: "white",
        },
    },
});

export const HeaderBox = ({ ...props }) => {

    const storeProvider = useStore();
    const classes = useStyles();

    const [isMultistore, setIsMultistore] = useState(true);
    const [showMultistoreSelect, setShowMultistoreSelect] = useState(false);
    const [selectedStore, setSelectedStore] = useState("$default")
    const [stores, setStores] = useState([]);

    useEffect(() => {
        const lastMultistore = storeProvider.getInitialSelectedStore()
        setSelectedStore(lastMultistore ? lastMultistore.id : "$default")
        const multistore = localStorage.getItem('multistore');
        setIsMultistore(JSON.parse(multistore));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const lastMultistore = storeProvider.selectedMultistore
        setSelectedStore(lastMultistore ? lastMultistore.id : "$default")
    }, [storeProvider.selectedMultistore])

    useEffect(() => {
        setShowMultistoreSelect(storeProvider.getMultistoreState())
        setStores(storeProvider.multistores)
    }, [storeProvider])


    const selectMultistore = (storeId) => {
        setSelectedStore(storeId)
        storeProvider.setLastSelectedStore(storeId)
    }

    return (
        <Wrapper style={{ alignItems: 'center' }}>
            <LogoWrapper>
                <StoreLogo />
            </LogoWrapper>
            <NameWrapper>
                {
                    !isMultistore && (
                        <>
                            <StoreName />
                            <StoreStatus
                                storeId={selectedStore === '$default' ? undefined : selectedStore || undefined}
                                deliveryStatusProp={true}
                                counterStatusProp={false}
                            />
                        </>
                    )
                }
                {
                    showMultistoreSelect && (
                        <>
                            <Select
                                label={'Selecionar loja'}
                                style={{ marginRight: '22px' }}
                                defaultValue={selectedStore ?? "$default"}
                                value={selectedStore}
                                className={classes.select}
                                onChange={(event) => selectMultistore(event.target.value)}
                            >
                                <MenuItem disabled value={"$default"}> Selecionar loja</MenuItem>
                                {stores.map((store, key) => {
                                    const { id, name, baseToReplicateItems } = store;
                                    return (
                                        <MenuItem value={id} key={key}>
                                            <MenuWrapper>
                                                <div> {name}</div>
                                                {
                                                    baseToReplicateItems &&
                                                    <StoreBaseWrapper>
                                                        {store.baseToReplicateItems && <span>Loja base</span>}
                                                        <Tooltip arrow title={"Loja onde os produtos devem ser criados para a funcionalidade de réplica de produtos e/ou cardápio."}>
                                                            <HelpOutline fontSize='small' style={{ color: '#000' }} />
                                                        </Tooltip>
                                                    </StoreBaseWrapper>
                                                }
                                            </MenuWrapper>
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </>
                    )
                }
                {
                    (isMultistore && selectedStore !== '$default') && (
                        <StoreStatus
                            isMultistore={isMultistore}
                            storeId={selectedStore === '$default' ? undefined : selectedStore || undefined}
                            deliveryStatusProp={true}
                            counterStatusProp={false}
                        />
                    )
                }

            </NameWrapper>

            <NotificationWrapper>
                {/* <NotificationButton number={0} /> */}
            </NotificationWrapper>
            <UserDropdownWrapper>
                <UserDropdown name={"Sair"} />
            </UserDropdownWrapper>
        </Wrapper>
    )
}
